import React from "react"

import { useFixedColumns } from "../hooks/useFixedColumns"

/**
 * A context aware colGroup to fix column width
 */
export function ColGroup() {
  const fixedColumns = useFixedColumns()

  if (!fixedColumns.length) {
    return null
  }

  return (
    <colgroup>
      {fixedColumns.map((width, index) => {
        if ((!width || width < 0) && width !== 0) {
          return <col key={index} />
        }

        return <col key={index} style={{ width }} />
      })}
    </colgroup>
  )
}
